import React from "react";
import { Container, Grid, Card, Typography, Box, Chip, Stack } from "@mui/material";
import SectionHeading from "./SectionHeading";
import { colors, fonts, ui } from "../theme";

const programs = [
  {
    code: "CRSP",
    name: "Crescent Research Scholar Program",
    positioning: "Research Awareness, Academic Excellence & Original Formulation",
    designedFor: "Final-year students, PG scholars, research aspirants & faculty",
    focus: ["Advanced Research Methodologies", "Structured Literature Review", "Peer-Reviewed Paper Architecture", "Patent Filing", "Academic Writing"],
    outcome: "Enhanced research outputs and measurable growth in patent registrations.",
  },
  {
    code: "CIIP",
    name: "Crescent Industry Immersion Program",
    positioning: "Industry-Oriented Immersive Internship & Modern Ecosystem Development",
    designedFor: "Students seeking industrial readiness & strong portfolios",
    focus: ["Full Stack Web Development", "Enterprise Cloud Computing", "Applied AI", "Generative AI Systems", "Scalable Data Analytics"],
    outcome: "Higher employment metrics, verified industrial readiness & standout portfolios.",
  },
  {
    code: "CPEP",
    name: "Crescent Project Excellence Program",
    positioning: "Rigorous Academic Project Mentoring for Departmental Excellence",
    designedFor: "Project teams preparing for external reviews",
    focus: ["Detailed Planning Models", "Distributed Tiered Architectures", "Continuous Implementation Reviews", "Technical Presentation Prep"],
    outcome: "Upgraded departmental repositories and confident external-review performance.",
  },
  {
    code: "CFTAS",
    name: "Crescent Faculty Technology Advancement Series",
    positioning: "Continuous Faculty Professional Development & Emerging Tech Track",
    designedFor: "Faculty members across engineering departments",
    focus: ["Enterprise Cloud Infrastructure", "MLOps", "Generative AI Pipelines", "Container Management", "Applied Cybersecurity"],
    outcome: "Rapid faculty upskilling and faster adoption of modern classroom technologies.",
  },
  {
    code: "CICP",
    name: "Crescent Innovation Catalyst Program",
    positioning: "Campus-Wide Innovation, Problem-Solving & Prototyping Ecosystem",
    designedFor: "Interdisciplinary teams & aspiring entrepreneurs",
    focus: ["User-Centric Design Thinking", "Interdisciplinary Hackathons", "Complex Problem Solving", "MVP Prototyping"],
    outcome: "A vibrant innovation culture and increased participation in national challenges.",
  },
];

const Programs = () => {
  return (
    <section id="programs-section" className="programs-section">
      <Box sx={{ background: colors.bgGradient, py: { xs: 5, md: 7 } }}>
        <Container>
          <SectionHeading
            eyebrow="Flagship Academic Programs"
            title="Five Structured Programs, Built Into Your Department Calendar"
            subtitle="Each program is designed as a premium academic initiative — seamlessly integrated as a long-term engagement rather than a one-off workshop."
          />
          <Grid container spacing={3}>
            {programs.map((p) => (
              <Grid item xs={12} md={6} lg={4} key={p.code}>
                <Card
                  elevation={0}
                  sx={{
                    ...ui.cardHover,
                    height: "100%",
                    borderRadius: 3,
                    border: "1px solid #e6edf7",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ background: colors.navy, color: colors.white, p: 2.5 }}>
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <Box
                        sx={{
                          background: colors.brandGradient,
                          borderRadius: 1.5,
                          px: 1.4,
                          py: 0.6,
                          fontFamily: fonts.heading,
                          fontWeight: 800,
                          fontSize: "0.85rem",
                        }}
                      >
                        {p.code}
                      </Box>
                      <Typography sx={{ fontFamily: fonts.heading, fontWeight: 700, fontSize: "1rem", lineHeight: 1.25 }}>
                        {p.name}
                      </Typography>
                    </Stack>
                  </Box>
                  <Box sx={{ p: 2.5, flexGrow: 1, display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ color: colors.blueDark, fontWeight: 600, fontSize: "0.85rem", mb: 1.5 }}>
                      {p.positioning}
                    </Typography>
                    <Typography sx={{ color: colors.textMuted, fontSize: "0.82rem", mb: 1.5 }}>
                      <strong style={{ color: colors.navy }}>Designed for:</strong> {p.designedFor}
                    </Typography>
                    <Stack direction="row" flexWrap="wrap" gap={0.7} sx={{ mb: 2 }}>
                      {p.focus.map((f) => (
                        <Chip
                          key={f}
                          label={f}
                          size="small"
                          sx={{
                            bgcolor: "#eef3fb",
                            color: colors.navy,
                            fontSize: "0.72rem",
                            fontWeight: 500,
                          }}
                        />
                      ))}
                    </Stack>
                    <Box sx={{ mt: "auto", borderTop: "1px dashed #dbe4f0", pt: 1.5 }}>
                      <Typography sx={{ color: colors.blueInk, fontWeight: 700, fontSize: "0.7rem", letterSpacing: "0.06em", mb: 0.5 }}>
                        INSTITUTIONAL OUTCOME
                      </Typography>
                      <Typography sx={{ color: colors.navy, fontSize: "0.86rem", lineHeight: 1.5 }}>
                        {p.outcome}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </section>
  );
};

export default Programs;
